export default "__VITE_ASSET__CdV$SBiR__"